// Utilitários para conversão de enums do backend (strings) para frontend (números)

export const convertEnumContainerTipo = (valor: string | number): number => {
  if (typeof valor === 'number') return valor;
  const enumMap: { [key: string]: number } = {
    PARCEL: 0,
    FRONTEND: 1,
    BACKEND: 2,
    BIBLIOTECA: 3,
    FULLSTACK: 4,
    WEBCOMPONENT: 5,
    ORQUESTRADOR: 6,
  };
  return enumMap[valor] ?? 1; // Default to FRONTEND
};

export const convertEnumContainerLinguagem = (
  valor: string | number
): number => {
  if (typeof valor === 'number') return valor;
  const enumMap: { [key: string]: number } = {
    DOTNET: 0,
    REACTJS: 1,
    DELPHI: 2,
    PHP: 3,
    NODEJS: 4,
    STENCILJS: 5,
    JAVASCRIPT: 6,
    SINGLESPA: 7,
  };
  return enumMap[valor] ?? 1; // Default to REACTJS
};

export const convertEnumBancoDeDados = (valor: string | number): number => {
  if (typeof valor === 'number') return valor;
  const enumMap: { [key: string]: number } = {
    MSSQL: 0,
    MONGODB: 1,
    MYSQL: 2,
    COSMOSDB: 3,
    STORAGE: 4,
  };
  return enumMap[valor] ?? 0; // Default to MSSQL
};

export const convertEnumMensageriaDirecao = (
  valor: string | number
): number => {
  if (typeof valor === 'number') return valor;
  const enumMap: { [key: string]: number } = {
    PUBLICA: 0,
    CONSOME: 1,
    PUBLICACONSOME: 2,
  };
  return enumMap[valor] ?? 0; // Default to PUBLICA
};

// Função para converter dados completos do backend
export const convertBackendDataToFrontend = (data: any) => {
  if (!data) return data;

  return {
    ...data,
    usuariosSistema: (data.usuariosSistema || []).map((usuario: any) => ({
      ...usuario,
      container: convertEnumContainerTipo(usuario.container),
    })),
    containers: (data.containers || []).map((container: any) => ({
      ...container,
      tipo: convertEnumContainerTipo(container.tipo),
      linguagem: convertEnumContainerLinguagem(container.linguagem),
      acessoContainers: (container.acessoContainers || []).map(
        (acesso: any) => ({
          ...acesso,
          tipo: convertEnumContainerTipo(acesso.tipo),
        })
      ),
    })),
    integracoes: (data.integracoes || []).map((integracao: any) => ({
      ...integracao,
      acessoContainers: (integracao.acessoContainers || []).map(
        (acesso: any) => ({
          ...acesso,
          containerOrigem: convertEnumContainerTipo(acesso.containerOrigem),
          containerDestino: convertEnumContainerTipo(acesso.containerDestino),
        })
      ),
    })),
    bancosDeDados: (data.bancosDeDados || []).map((banco: any) => ({
      ...banco,
      tipo: convertEnumBancoDeDados(banco.tipo),
      acessoContainers: (banco.acessoContainers || []).map((acesso: any) => ({
        ...acesso,
        tipo: convertEnumContainerTipo(acesso.tipo),
      })),
    })),
    mensagerias: (data.mensagerias || []).map((mensageria: any) => ({
      ...mensageria,
      acessoContainers: (mensageria.acessoContainers || []).map(
        (acesso: any) => ({
          ...acesso,
          tipo: convertEnumContainerTipo(acesso.tipo),
          direcao: convertEnumMensageriaDirecao(acesso.direcao),
        })
      ),
    })),
    camadas: (data.camadas || []).map((camada: any) => ({
      ...camada,
      container: convertEnumContainerTipo(camada.container),
      componentes: (camada.componentes || []).map((comp: any) => ({
        ...comp,
        acessoComponentes: comp.acessoComponentes || [],
        acessoSistemas: comp.acessoSistemas || [],
      })),
    })),
  };
};
